export default __webpack_public_path__ + "static/media/playwrightTesting.bd26c9ab.md";